// removed by extract-text-webpack-plugin
module.exports = {"container":"_343Rt7q3uMscr5QxS0DDqJ","signaturesContainer":"d6JHX41Xy7pbEQue2mrkD","deleteButton":"_3wsAwV_UEdpCmIs4iepTDj","signatureContainer":"_20dxT_2S8YNhgKhsfBbeRr","defaultSignature":"_2A93mTZxcMqQ-tPR45pX6k","mainSignature":"zVU-fFxqQyEmPXD9yTea3"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/Settings/Signature/MySignaturesMini/styles.css
// module id = 2563
// module chunks = 0